export default __webpack_public_path__ + "static/media/rockpaperscissors.12bbdd6d.png";